import { Component, inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppConfig } from 'client/app/app.config';
import { LocalStorageService } from '@services/local-storage-service';
import { EventLoggerService } from '@services/event-logger-service';

import { ButtonModule } from '@components/button';
import { ApiClientConstant } from '@cureskin/api-client';

@Component({
  selector: 'side-face-photo-bottom-sheet',
  imports: [
    ButtonModule
],
  templateUrl: './side-face-photo-bottom-sheet.component.html',
})
export class SideFacePhotoBottomSheetComponent implements OnInit {
  static readonly DISMISS_UPLOAD = 'UPLOAD';
  static readonly DISMISS_SKIP = 'SKIP';
  availableImages: Array<{ image: string; side: string }> = [];
  frontFaceImage: { image: string; side: string } | null = null;
  sideFaceImage: { image: string; side: string } | null = null;
  requiredSide: string;

  data: any = inject(MAT_BOTTOM_SHEET_DATA);
  appConfig: AppConfig = inject(AppConfig);
  private readonly bottomSheetRef: MatBottomSheetRef = inject(MatBottomSheetRef);
  private readonly localStorage: LocalStorageService = inject(LocalStorageService);
  private readonly eventLogger: EventLoggerService = inject(EventLoggerService);

  ngOnInit(): void {
    this.requiredSide = this.data.requiredSide;
    this.availableImages = this.data.availableImages ?? [];

    this.frontFaceImage = this.availableImages.find(
      (img: { image: string; side: string }): boolean => img.side === this.appConfig.Shared.InstantCheckup.Type.FRONT_FACE,
    )

    this.eventLogger.cleverTapEvent('impression', JSON.stringify({ name: 'side_face_photo_bottomsheet'}));
  }

  uploadImage(): void {
    if (!this.data.callback) return

    this.localStorage.setValue('expectedFacePhoto', this.data.requiredSide ?? ApiClientConstant.InstantCheckup.Type.SIDE_FACE);
    this.bottomSheetRef.dismiss(SideFacePhotoBottomSheetComponent.DISMISS_UPLOAD);
    this.data.callback();
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'take_side_face_photo'}));
  }

  closePopup(): void {
    this.bottomSheetRef.dismiss(SideFacePhotoBottomSheetComponent.DISMISS_SKIP);
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'side_face_photo_bottomsheet_close'}));
  }
}
